const sectionCode = "SPRO2";
const chartCode = "C022x";

import { Procedures } from "modules/provider/shared/procedure-charts";

function T22Procedures() {
  return <Procedures chartCode={chartCode} sectionCode={sectionCode} />;
}

export { T22Procedures };
